import React from 'react';
import { Link } from 'react-router-dom';
import { getNavigationLabel } from '../constants/management';
import './OperatingContextUnavailablePage.css';

interface Props {
  replacementPath?: string;
}

const OperatingContextUnavailablePage: React.FC<Props> = ({ replacementPath }) => (
  <main className="page-shell operating-context-unavailable">
    <h1>Модуль недоступний у режимі ресторану</h1>
    <p>
      Ця сторінка ще не підтримує роботу в контексті окремої операційної групи.
      Зміна ролі користувача не усуне це обмеження.
    </p>
    {replacementPath && (
      <p>
        Замість неї відкрийте{' '}
        <Link to={replacementPath}>{getNavigationLabel(replacementPath)}</Link>.
      </p>
    )}
    <Link to="/operating-contexts">Керувати контекстом роботи</Link>
  </main>
);

export default OperatingContextUnavailablePage;
